import { cn } from "@/lib/utils";
import {
  ArrowUpRight,
  CheckCircle,
  ExternalLink,
  TriangleAlert,
} from "lucide-react";
import React from "react";
import { Button } from "@/components/ui/button";

export const VercelDeploymentBlock = React.memo(
  ({ previewUrl, claimUrl }: { previewUrl: string; claimUrl: string }) => {
    return (
      <div>
        <p className="text-xs font-medium text-secondary-n-50 mb-4">
          Deployed to Vercel
        </p>
        <div
          className={cn("flex flex-col grow bg-secondary-n-950 p-2 rounded-md")}
        >
          <div className="flex flex-col gap-1 -mt-2">
            <div className="flex flex-row justify-between items-center space-x-2 mt-2  rounded-md">
              <div
                className="bg-secondary-n-950 text-white  rounded-md overflow-hidden flex flex-row items-center gap-2 cursor-pointer"
                onClick={() => window.open(previewUrl, "_blank")}
              >
                <img
                  src="/icons/ai-chat-status/success.svg"
                  className="size-4 shrink-0"
                />
                <p className="truncate text-xs text-secondary-n-50 font-['Inconsolata'] font-medium">
                  {previewUrl}
                </p>
              </div>
              <div className="flex pr-1">
                <ArrowUpRight
                  className="cursor-pointer w-4 h-4 text-secondary-n-50 shrink-0"
                  onClick={() => window.open(previewUrl, "_blank")}
                />
              </div>
            </div>
            <div className="flex flex-col gap-2 mt-2 bg-secondary-0 p-2 rounded-lg">
              <p className="text-xs text-gray-100">
                Claim it to manage in Vercel and deploy to a custom domain.
              </p>
              <span className="flex flex-row items-center gap-2">
                <TriangleAlert className="w-4 h-4 text-[#E17100] shrink-0" />
                <p className="text-xs text-secondary-800">
                  This link expires in 48 hours.
                </p>
              </span>
              <Button
                variant="default"
                className="text-xs font-medium bg-primary-0 hover:bg-primary-100 whitespace-nowrap rounded-md h-8"
                onClick={() => window.open(claimUrl, "_blank")}
              >
                Claim Now
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  },
);
